import { render, staticRenderFns } from "./full-screen-popup.vue?vue&type=template&id=4ba04b0f&"
import script from "./full-screen-popup.vue?vue&type=script&lang=js&"
export * from "./full-screen-popup.vue?vue&type=script&lang=js&"
import style0 from "./full-screen-popup.vue?vue&type=style&index=0&id=4ba04b0f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports